<div class="table-setup-wizard">
  <form class="table-setup-wizard__form" [formGroup]="setupForm">
    <div class="table-setup-wizard__intro">
      <h2>Table Setup</h2>
      <p>
        Use this tile to show datasource records in a table. Choose the datasource, decide how the
        table should paginate, and then choose which columns should appear and in what order.
      </p>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" />
      <mat-hint>Sets the heading shown above the table tile.</mat-hint>
    </mat-form-field>

    <app-data-source-selector
      formControlName="dataSource"
      hint="Chooses which datasource supplies the rows and available columns."
      (onDataSourceChange)="initTableShowColumnsOptions($event)"
    ></app-data-source-selector>

    <div class="table-setup-wizard__options">
      <p class="table-setup-wizard__options-intro">
        These options control pagination and what happens when a user opens a row.
      </p>
      <mat-checkbox class="example-margin" formControlName="showPageControls"
        >Show page controls</mat-checkbox
      >
      <mat-checkbox class="example-margin" formControlName="showPageSizeOptions"
        >Show page size options</mat-checkbox
      >
      <mat-checkbox class="example-margin" formControlName="openInDrawer"
        >Open row in drawer (instead of route navigation)</mat-checkbox
      >
    </div>

    <div class="table-columns-section">
      <div class="table-columns-section__header">
        <h2>Table Columns</h2>
        <p>Drag selected rows to set the rendered column order.</p>
      </div>

      <div
        class="table-columns"
        cdkDropList
        cdkDropListOrientation="vertical"
        [cdkDropListData]="tableShowColumnsOptions"
        (cdkDropListDropped)="onColumnDrop($event)"
      >
        <div class="table-column-row" *ngFor="let option of tableShowColumnsOptions" cdkDrag>
          <button
            type="button"
            class="table-column-row__handle"
            mat-icon-button
            cdkDragHandle
            [disabled]="!isChecked(option.name)"
            [attr.aria-label]="'Drag ' + (option.displayName || option.name)"
          >
            <mat-icon>drag_indicator</mat-icon>
          </button>

          <mat-checkbox
            class="table-column-row__checkbox"
            [checked]="isChecked(option.name)"
            (change)="onColumnSelectionChange(option.name, $event.checked)"
          >
            {{ option.displayName || option.name }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </form>

  <div class="table-setup-wizard__footer">
    <suvo-error-list [errors]="errors"></suvo-error-list>
    <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
  </div>
</div>
